import { useDispatch } from 'react-redux';
import React from 'react';
import UpdatePasswordForm from '../PasswordChange/PasswordChange';
import { setForgetPassword } from '../../redux/forgetPassword/forgetPasswordSlice';

function ForgetPasswordNewPassword() {
  const dispatch = useDispatch();

  const handlePasswordChange = (password: string) => {
    dispatch(setForgetPassword(password));
  };

  return <UpdatePasswordForm mode="RESET_PASSWORD" onPasswordChange={handlePasswordChange} />;
}

export default ForgetPasswordNewPassword;
